import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';

/**
 * Copy VE form
 */
@Component({
  selector: 'copy-valuation-event-form',
  templateUrl: './copy-valuation-event-form.component.html',
  styleUrls: ['./copy-valuation-event-form.component.css']
})
export class CopyValuationEventFormComponent implements OnInit {
  /**
   * The form group
   */
  formData: UntypedFormGroup;

  /**
   * Valuation date invalid?
   */
  valuationDateInvalid: boolean;

  /**
   * Original data
   */
  originalData: any;

  /**
   * Period of valuation
   */
  @Input() periodofvaluation;

  /**
   * Copy VE data
   */
  @Input() copyValuationPortfolioData;

  /**
   * Properties count
   */
  @Input() propertiesCount;

  /**
   * Available valuation periods
   */
  @Input() availableValuationPeriods;

  /**
   * Original data
   * @param value
   */
  @Input() originalValuationPortfolioData(value: any) {
    if (value) {
      this.originalData = value;
    }
  }

  /**
   * Sets the form
   */
  @Input() set form(value: UntypedFormGroup) {
    if (value) {
      this.formData = value;
    }
  }

  /**
   * Sets the read-only flag
   */
  @Input() set readonly(value: boolean) {
    if (value) {
      this.formData.disable();
    }
    else {
      this.formData.enable();
    }
  }

  /**
   * Enable save?
   */
  @Output() enableSaveOnPortfolioData: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  /**
   * Constructor
   * @param cd
   */
  constructor(readonly cd: ChangeDetectorRef) {
    //Nothing
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.setValautionEventName();
    this.cd.markForCheck();
  }

  /**
   * Check required fields
   */
  checkRequiredFieldsForValuationPortfolioName() {
    this.setValautionEventName();

    this.enableSaveOnPortfolioData.emit(false);
    if (this.formData.controls.PeriodOfValuationID.value == 1) {
        this.enableSaveOnPortfolioData.emit(this.formData.controls.ValuationDate.value && !!this.formData.controls.DivisionOfPortfolio.value);
    }
    else if (this.formData.controls.PeriodOfValuationID.value == 3) {
      if (!this.formData.controls.ValuationDate.value && !this.formData.controls.DivisionOfPortfolio.value) {
        this.enableSaveOnPortfolioData.emit(false);
      } else if (!this.formData.controls.ValuationPeriodId.value && !!this.formData.controls.DivisionOfPortfolio.value) {
        this.enableSaveOnPortfolioData.emit(!this.formData.controls.ValuationPeriodId.value && !!this.formData.controls.DivisionOfPortfolio.value);
      }     
    }
    else {
      this.formData.controls.Scenario.setValue(0);
      this.formData.controls.DivisionOfPortfolio.setValue(0);
      this.enableSaveOnPortfolioData.emit(true);
    }
  }

  /**
   * Builds the VE name
   */
  setValautionEventName() {
    this.copyValuationPortfolioData.ValuationPortfolioName = this.formData.controls['ValuationPortfolioName'].value;
    const newValuationDate = this.formData.controls.ValuationDate.value ? this.formData.controls.ValuationDate.value : new Date(this.copyValuationPortfolioData.ValuationDate);
    const oldValuationDate = new Date(this.originalData?.ValuationDate);
    this.valuationDateInvalid = oldValuationDate.getFullYear() == newValuationDate.getFullYear() && oldValuationDate.getMonth() == newValuationDate.getMonth() && oldValuationDate.getDate() == newValuationDate.getDate();

    this.copyValuationPortfolioData.ValuationPortfolioName = '';
    if (newValuationDate) {

      const date = newValuationDate;
      if (date) {
        if (date instanceof Date) {
          this.copyValuationPortfolioData.ValuationPortfolioName += moment(new Date(date), "yyyyMMdd");
        }
      }
    }
    if (this.formData.controls.ValuationDateDescription.value) {
      if (this.copyValuationPortfolioData.ValuationDateDescription.length == 10) {
        const dateString = this.copyValuationPortfolioData.ValuationDateDescription;
        const day = dateString.substring(0, 2);
        let month = dateString.substring(3, 5);
        const year = dateString.substring(6);
        month = month - 1;
        this.copyValuationPortfolioData.ValuationPortfolioName += moment(new Date(year, month, day), "yyyyMMdd");
      }
    }

    if (this.formData.controls.ClientManual.value) {
      this.copyValuationPortfolioData.ValuationPortfolioName += '_';
      this.copyValuationPortfolioData.ValuationPortfolioName += this.formData.controls.ClientManual.value;
      this.formData.controls['ValuationPortfolioName'].setValue(this.copyValuationPortfolioData.ValuationPortfolioName);
    }

    if (this.formData.controls.ProjectName.value) {
      this.copyValuationPortfolioData.ValuationPortfolioName += '_';
      this.copyValuationPortfolioData.ValuationPortfolioName += this.formData.controls.ProjectName.value;
      this.formData.controls['ValuationPortfolioName'].setValue(this.copyValuationPortfolioData.ValuationPortfolioName);
    }

    if (this.copyValuationPortfolioData.Remark) {
      this.copyValuationPortfolioData.ValuationPortfolioName += '_';
      this.copyValuationPortfolioData.ValuationPortfolioName += this.formData.controls['Remark'].value;
      this.formData.controls['ValuationPortfolioName'].setValue(this.copyValuationPortfolioData.ValuationPortfolioName);
    }
  }
}
